module.exports = __webpack_public_path__ + "static/syla-icon-42d8306cd636a61c4c1ec4c39ed3caee.png";